import OZakazkaNDTable from './components/tableND.vue';
import { NAME } from './constants';
import { router } from './router';

export const NahradniDily = {
	name: NAME,
	router,
	components: {
		OZakazkaNDTable,
	},
};
